import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';

const Holder = styled.div`
  margin: 48px 0;
  padding-bottom: 48px;
  border-bottom: 1px solid #dbdfe5;
  &:last-child {
    border-bottom: unset;
  }

  b.break {
    white-space: pre;
  }

  .blueText {
    color: #0751c2;
  }

  .supportEmail {
    font-weight: 600;
    color: #17233c;
  }

  ${mediaMSmMax} {
    margin: 36px 0;
    padding-bottom: 36px;
  }

  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 16px;
    ${mediaMSmMax} {
      font-size: 18px;
      line-height: 24px;
    }
  }

  div {
    p {
      font-size: 14px;
    }
  }

  .options {
    padding-top: 30px;
    .option {
      display: flex;
      &:not(:last-child) {
        padding-bottom: 20px;
      }

      .title {
        margin: auto 0;
      }

      .switch {
        width: auto;
        margin-left: auto;
      }
    }
  }
`;

export default Holder;
